var vf = typeof window !== "undefined" ? window.vf : undefined;
if (!vf || typeof vf.vsTable !== "function") throw new Error("[vfunc-ui-data] load vfunc-ui.js before this file.");
export default vf;
